import React from 'react';
import { Link } from 'react-router-dom';
import { MeatballMenu, PromptConfirmationModal } from 'ui';
import { isDisabled } from 'app/infrastructure/data/date';
import { Tag } from 'app/components/tag';
import { routeConstants } from 'app/routes/route-constants';
import { ListItemProps } from 'app/area/company-reports-administration/list/types-store';
import styles from './list-item.scss';

export const ListItem: React.FC<ListItemProps> = ({
  item, deleting, deleteCompanyReport, translation
}) => {

  const disabled = isDisabled(item.code.disabled);

  const handleDelete = () => {
    deleteCompanyReport(item.code.value, translation.company_report_deleted);
  };

  return <div className={styles.companyReportRow}>
    {!deleting
      ? <Link className={styles.companyReportName} to={routeConstants.companyReportAdminItemFor(item.code.value)}>
        {item.code.description}
      </Link>
      : <div className={styles.companyReportName}>{item.code.description}</div>}
    {disabled
      ? <Tag className={styles.disabledTag}>
        {translation.disabled}
      </Tag>
      : null}
    <div className={styles.meatballContainer}>
      <MeatballMenu
        id={`meatball-${item.code.value}`}
        className={styles.meatball}>
        <li>
          {deleting
            ? <span className="dropdown-item disabled">{translation.edit_company_report}</span>
            : <Link className="dropdown-item" to={routeConstants.companyReportAdminItemFor(item.code.value)}>
              {translation.edit_company_report}
            </Link>}
        </li>
        {!disabled && <li>
          <Link className="dropdown-item" to={routeConstants.companyReportFor(item.code.value)}>
            {translation.run_company_report}
          </Link>
        </li>}
        <li>
          <PromptConfirmationModal
            title={translation.delete_company_report}
            description={translation.delete_confirmation}
            continueText={translation.delete_company_report}
            cancelText={translation.cancel}
            onContinue={handleDelete}>
            <button type="button"
              className="dropdown-item"
              disabled={deleting}>
              {translation.delete_company_report}
            </button>
          </PromptConfirmationModal>
        </li>
      </MeatballMenu>
    </div>
  </div>;
};
